<template>
  <div class="PaB-product-listing" v-if="loaded">
    <h2 class="PaB-product-listing__title">{{ category.name }}
      <span class="PaB-category-info-link" @click="showCategoryInfo = true" v-if="category.slug !== 'all'" :title="`${category.name} information`">
        <icon-base width="16" height="16">
          <icon-question-circle />
        </icon-base>
      </span>
    </h2>

    <div class="PaB-product-list" :class="{'PaB-product-display--list': view == 'list', 'PaB-product-display--grid': view == 'grid' }">
      <product-card v-for="product in products" :key="product.guid" :product="product" :layout="view" :orderable="widgetOptions.config.allow_orders"></product-card>
      <div class="PaB-product-card-shim"></div>
      <div class="PaB-product-card-shim"></div>
      <div class="PaB-product-card-shim"></div>
      <div class="PaB-product-card-shim"></div>
      <div class="PaB-product-card-shim"></div>
    </div>

    <div class="PaB-products__no-results" v-if="products.length === 0 && loaded">
      <h4>No Results</h4>
      <p>
        <a href="#" v-if="searchTerm !== ''" @click="clearSearch($event)">Clear Search</a>
        <span v-if="searchTerm !== '' && activeFilters.length > 0"> or </span>
        <a href="#" v-if="activeFilters.length > 0" @click="clearFilters($event)">Clear Filters</a>
      </p>
      <p v-if="category.slug !== 'all'">Try looking in <router-link :to="{name: 'product-listing', params: { category: 'all' } }">all
          products</router-link>
      </p>
    </div>

    <app-modal v-if="showCategoryInfo" @close="showCategoryInfo = false" width="600px">
      <template slot="body">
        <header class="PaB-category__header" v-if="category.image.md && widgetOptions.style.product_images">
          <div class="PaB-category__media">
            <img :src="category.image.md" class="PaB-attachment-card-lg PaB-size-card-lg" :alt="category.name">
          </div>
        </header>

        <div class="PaB-category__body">
          <h3 class="PaB-category__title">{{ category.name }}</h3>
          <p class="PaB-category__description">{{ category.description }}</p>
          <app-button @click.native="showCategoryInfo = false" label="Shop Products" type="primary"></app-button>
        </div>
      </template>
    </app-modal>

    <router-view></router-view>
  </div>
</template>

<style lang="scss">
.PaB-product-display--list {
  .PaB-product-card {
    display: flex;
    flex-direction: row;
    margin: 10px 0;
  }
}

.PaB-product-listing {
  margin-top: 40px;
  overflow: hidden;
}

.PaB-product-listing__title {
  padding-bottom: 5px;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
  border-bottom: 1px solid #b2b2b2;
}

.PaB-category-info-link {
  cursor: pointer;
  font-size: 16px;
}

.PaB-category__media {
  height: 0;
  padding-bottom: 200 / 360 * 100%;
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;

  img {
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
}
.PaB-category__body {
  text-align: center;
  padding: 30px;

  .PaB-category__description {
    width: 440px;
    margin: auto;
    max-width: 100%;
  }

  .PaB-category__title {
    margin-bottom: 15px;
    font-weight: bold;
  }

  .PaB-button {
    display: block;
    margin: auto;
    width: 320px;
    max-width: 100%;
    margin-top: 30px;
  }
}

.PaB-product-display--grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: -10px;
  margin-right: -10px;

  .PaB-product-card-shim,
  .PaB-product-card-wrapper {
    flex: 1 1 320px;
    margin: 10px;
  }

  .PaB-product-card-shim {
    height: 0;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>

<script>
import ProductCard from '@/components/ProductCard'
import AppModal from '@/components/AppModal'
import AppButton from '@/components/AppButton'
import IconBase from '@/components/IconBase'
import IconQuestionCircle from '@/components/icons/IconQuestionCircle'

export default {
  name: 'ProductList',

  data () {
    return {
      showCategoryInfo: false
    }
  },

  components: {
    ProductCard,
    AppModal,
    AppButton,
    IconBase,
    IconQuestionCircle
  },

  computed: {
    view () {
      return this.$store.state.products.view
    },
    products () {
      return this.$store.getters['products/getProducts']
    },
    category () {
      return this.$store.getters['products/getCategory']
    },
    loading () {
      return this.$store.state.products.loading
    },
    loaded () {
      return this.$store.state.products.loaded
    },
    searchTerm () {
      return this.$store.state.products.search
    },
    activeFilters () {
      return this.$store.getters['products/getActiveFilters']
    }
  },

  created () {
    this.$store.dispatch('products/setCategory', this.$route.params.category)

    if (this.$route.name === 'product-listing') {
      this.eventTracking.sendPageview(this.$router.currentRoute.fullPath)
    }
  },

  watch: {
    $route (to, from) {
      this.$store.dispatch('products/setCategory', this.$route.params.category)
      if (to.name === 'product-listing') {
        this.eventTracking.sendPageview(this.$router.currentRoute.fullPath)
      }
    }
  },

  methods: {
    clearSearch (e) {
      if (e) { e.preventDefault() }
      this.$store.dispatch('products/search', '')
    },
    clearFilters (e) {
      if (e) { e.preventDefault() }
      this.$store.dispatch('products/resetFilters')
    }
  }
}
</script>
